import { render, staticRenderFns } from "./dynamicForm.vue?vue&type=template&id=239b9ce4&scoped=true"
import script from "./dynamicForm.vue?vue&type=script&lang=js"
export * from "./dynamicForm.vue?vue&type=script&lang=js"
import style1 from "./dynamicForm.vue?vue&type=style&index=1&id=239b9ce4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239b9ce4",
  null
  
)

export default component.exports